import { IPublicRestaurant } from '@localina/core';
import { formatNumber } from 'libphonenumber-js';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
    restaurant: IPublicRestaurant;
}

// Swiss numbers read the way guests dial them (044 …); anything else keeps its country code.
const formatPhoneNumber = (phoneNumber: string) =>
    formatNumber(phoneNumber, phoneNumber.startsWith('+41') ? 'NATIONAL' : 'INTERNATIONAL') || phoneNumber;

export const RestaurantHeader: React.FC<IProps> = ({ restaurant }) => {
    const { t } = useTranslation();

    return (
        <div className="widget-header">
            {restaurant.logo && (
                <span className="widget-header__logo">
                    <img className="logo" src={`${window.location.origin}/${restaurant.logo}`} alt="" />
                </span>
            )}
            <div className="widget-header__name">{restaurant.name}</div>
            {restaurant.phoneNumber && (
                <a className="widget-header__phone" href={`tel:${restaurant.phoneNumber}`}>
                    <span className="widget-header__phone-label">{t('reservation.header.call')}</span>
                    <span className="widget-header__phone-number">{formatPhoneNumber(restaurant.phoneNumber)}</span>
                </a>
            )}
        </div>
    );
};
